import React, { useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HomeScreen from './screens/HomeScreen';
import PilotScreen from './screens/PilotScreen';
import DroneScreen from './screens/DroneScreen';
import MaintenanceScreen from './screens/MaintenanceScreen';
import {
  getCurrentUserId,
  userAuthListener,
  userSignOut,
} from './firebase/auth-helper';
import LoginScreen from './screens/LoginScreen';
import SettingsScreen from './screens/SettingsScreen';
import {
  createSettingsItem,
  loadSettings,
  loadSharedUsers,
  saveSettings,
} from './firebase/db-settings';
import { SettingsType, UserType } from './interfaces/SettingsType';
import { LogType } from './interfaces/LogType';
import { MaintenanceLogType } from './interfaces/MaintenanceLogType';
import { loadLogs, saveLogs } from './firebase/db-logs';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<string>(
    window.location.pathname
  );
  const [accessAllowed, setAccessAllowed] = useState<boolean>();
  const [settings, setSettings] = useState<SettingsType>();
  const [pilots, setPilots] = useState<UserType[]>();
  const [logs, setLogs] = useState<LogType[]>();

  console.log(settings);
  useEffect(() => {
    userAuthListener(setAccessAllowed);
  }, []);

  async function updateSettings(val: SettingsType) {
    setSettings(val);
    await saveSettings(val);
  }

  const renderPage = () => {
    if (!accessAllowed) {
      navigateTo('/');
      return <></>;
    }

    if (!logs) {
      return <div>Daten werden geladen...</div>; 
    }

    switch (currentPage) {
      case '/':
        return <HomeScreen logs={logs} userName="Marvin" />;
      case '/logout':
        setSettings(undefined);
        userSignOut();
        navigateTo('/');
        return <></>;
      case '/pilot':
        return <PilotScreen settings={settings!} pilots={pilots!} />;
      case '/droneM350':
      case '/Matrice350RTK':
        return (
          <DroneScreen
            key="droneM350"
            settings={settings!}
            droneType="Matrice350RTK"
            pilots={pilots!}
          />
        );
      case '/droneM2EA':
      case '/69':
        return (
          <DroneScreen
            key="droneM2EA"
            settings={settings!}
            droneType={69}
            pilots={pilots!}
          />
        );

      case '/maintenance':
        return <MaintenanceScreen settings={settings!} initLogs={logs!} pilots={pilots!}/>;
      case '/settings':
        return (
          <SettingsScreen settings={settings} updateSettings={updateSettings} />
        );
      default:
        return <HomeScreen logs={logs} userName="Marvin" />;
    }
  };

  useEffect(() => {
    if (accessAllowed) loadData();
  }, [accessAllowed]);

  async function loadData() {
    const tempSettings = await loadSettings();
    if (tempSettings) {
      setSettings(tempSettings);
      const sharedUsers = await loadSharedUsers(tempSettings);
      setPilots(sharedUsers ? sharedUsers : tempSettings.userList);
    }

    const tempLogs = await loadLogs(10, undefined, []);
    if (tempLogs) setLogs(tempLogs);
  }

  useEffect(() => {
    const handlePopState = () => setCurrentPage(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = (path: string) => {
    window.history.pushState({}, '', path);
    setCurrentPage(path);
  };

  if (accessAllowed == undefined) {
    return <></>;
  }
  if (!accessAllowed) {
    return <LoginScreen />;
  }

  if (settings == undefined || logs == undefined) {
    return <></>;
  }

  if (
    accessAllowed === undefined ||
    settings === undefined ||
    logs === undefined
  ) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div>
      <Navbar
        onNavigate={navigateTo}
        currentPage={currentPage}
        settings={settings}
      />
      <div className="content">{renderPage()}</div>
    </div>
  );
};

export default App;
